'use strict';

jQuery($ => {
	$('body').prepend('<div id="fixed-header-padding"></div>');
	function set_fixed_header_height(){
		var fhp = $('#fixed-header-padding');
		var height = $('[data-fixed-header]:visible').outerHeight();
		$('#fixed-header-padding').height(height);
		//console.log($('[data-fixed-header]'));
	}
	$(window).resize(function(){
		set_fixed_header_height();
	})
	set_fixed_header_height();
});